import React, { useEffect, useRef, useState } from 'react';
import { Button } from '../ui/Button';

export const PDFPreview: React.FC<{ blob: Blob }> = ({ blob }) => {
  const canvas = useRef<HTMLCanvasElement>(null);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(() => { setPage(1); }, [blob]);
  useEffect(() => {
    let active = true;
    let dispose: (() => void) | undefined;
    setLoading(true);
    setError('');
    (async () => {
      const pdfjs = await import('pdfjs-dist/legacy/build/pdf.mjs');
      if (!active) return;
      const base = process.env.PUBLIC_URL === '.' ? '' : (process.env.PUBLIC_URL || '');
      pdfjs.GlobalWorkerOptions.workerSrc = `${base}/vendor/pdf.worker.min.mjs`;
      const data = new Uint8Array(await blob.arrayBuffer());
      if (!active) return;
      const task = pdfjs.getDocument({ data, isEvalSupported: false });
      dispose = () => { void task.destroy(); };
      const doc = await task.promise;
      if (!active) return;
      setPages(doc.numPages);
      const pdfPage = await doc.getPage(Math.min(page, doc.numPages));
      if (!active || !canvas.current) return;
      const viewport = pdfPage.getViewport({ scale: 1.25 });
      const target = canvas.current;
      target.width = viewport.width;
      target.height = viewport.height;
      const context = target.getContext('2d');
      if (!context) throw new Error('Canvas indisponível');
      await pdfPage.render({ canvasContext: context, viewport }).promise;
      if (active) setLoading(false);
    })().catch(error => {
      if (active) console.error('Erro ao renderizar a prévia do PDF:', error);
      if (active) { setLoading(false); setError('Não foi possível mostrar a prévia. Use Abrir PDF para visualizar o arquivo.'); }
    });
    return () => { active = false; dispose?.(); };
  }, [blob, page]);
  return <div>
    {loading && <p role="status">Carregando prévia...</p>}
    {error && <p role="alert">{error}</p>}
    <canvas ref={canvas} aria-label={`Prévia do PDF, página ${page}`} style={{ display: error ? 'none' : 'block', width: '100%', height: 'auto', background: '#fff' }} />
    {pages > 1 && <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
      <Button variant="secondary" disabled={page <= 1 || loading} onClick={() => setPage(p => p - 1)}>Anterior</Button>
      <span>Página {page} de {pages}</span>
      <Button variant="secondary" disabled={page >= pages || loading} onClick={() => setPage(p => p + 1)}>Próxima</Button>
    </div>}
  </div>;
};
